var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationObserver',{ref:"observerRef"},[_c('form',{attrs:{"novalidate":""}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }